import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "checked", "name", "value"]

import { PropType } from "vue";
import { MetadataAllowedValues } from "@/models/content-templates.model";
import { isMetadataValueChecked } from "@/utils/content-metadata-helpers";
import { MetadataInstance } from "@/models/product-section.model";
import { useMetadataStore } from "@/stores/metadata.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleOption',
  props: {
  instances: {
    required: true,
    type: Array as PropType<MetadataInstance[]>
  },
  value: {
    required: true,
    type: Object as PropType<MetadataAllowedValues>
  },
  currentInstance: {
    required: true,
    type: Object as PropType<MetadataInstance>
  },
  productId: {
    required: true,
    type: Number
  }
},
  setup(__props) {

const metadataStore = useMetadataStore();

const props = __props;

const getMetadataSingleAllocatedValueId = (): number | undefined => {
  if (
    props.currentInstance.metadata_definition.metadata_allocated_values.length >
    0
  ) {
    return props.currentInstance.metadata_definition
      .metadata_allocated_values[0].id;
  }
  return undefined;
};
const toggleMetadataAllocatedValue = async () => {
  const id = getMetadataSingleAllocatedValueId();
  if (id) {
    // delete old value
    const payloadToRemove = {
      id,
      productId: props.productId
    };
    await metadataStore.deleteMetadataAllocatedValues(payloadToRemove, false);
  }
  // set new value
  const payloadToAdd = {
    value: {
      metadata_allowed_value_id: Number(props.value.id),
      metadata_instance_id: props.currentInstance.id
    },
    productId: props.productId
  };
  await metadataStore.createMetadataAllocatedValues(payloadToAdd);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    id: __props.value.id,
    checked: _unref(isMetadataValueChecked)(__props.currentInstance, __props.value.id),
    name: __props.currentInstance.metadata_definition.name,
    value: __props.value.display_name,
    type: "radio",
    onChange: toggleMetadataAllocatedValue
  }, null, 40, _hoisted_1))
}
}

})